<script setup lang="ts">
defineSlots<{ default: () => void }>();
</script>

<template>
  <div class="overflow-hidden rounded-lg">
    <slot />
  </div>
</template>
